import { CreateCampaignInquiryLayout } from "./CreateCampaignInquiryLayout";

export const CampaignsInquiryCreatePage = () => {
    return <CreateCampaignInquiryLayout />;
};
